import useMutationTeamCreateUpdate from "./team-use-mutation-create-update";
import useMutationTeamDelete from "./team-use-mutation-delete.";

export const teamUseMutation = {
  createUpdate: useMutationTeamCreateUpdate,
  delete: useMutationTeamDelete,
};
